enum FilterEvents {
  engagedFacet = 'Engaged - Facet',
  removedFilter = 'Removed - Filter'
}

export default FilterEvents;
